import { render } from "./pageView.vue?vue&type=template&id=3c36e4e4&scoped=true"
import script from "./pageView.vue?vue&type=script&lang=js"
export * from "./pageView.vue?vue&type=script&lang=js"

import "./pageView.vue?vue&type=style&index=0&id=3c36e4e4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c36e4e4"]])

export default __exports__